var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#C13584",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0H4C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4C16 1.79086 14.2091 0 12 0ZM11.9567 7.41327C12.0801 8.24551 11.938 9.09548 11.5505 9.84228C11.163 10.5891 10.5499 11.1947 9.79836 11.5729C9.04684 11.9512 8.19518 12.0829 7.36452 11.9492C6.53386 11.8155 5.76649 11.4233 5.17158 10.8284C4.57665 10.2335 4.18447 9.46614 4.0508 8.63548C3.91714 7.80482 4.04881 6.95316 4.42706 6.20164C4.80533 5.45012 5.41092 4.83701 6.15772 4.44951C6.90452 4.06201 7.75449 3.91986 8.58673 4.04327C9.43565 4.16915 10.2216 4.56473 10.8284 5.17158C11.4353 5.77842 11.8308 6.56434 11.9567 7.41327ZM10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8ZM12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4C11 4.55228 11.4477 5 12 5Z",
    fill: "#c13584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.70133f96e4d6ca42bed75cd7545883a4.svg";
export { ForwardRef as ReactComponent };